import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface ActionIcon {
  icon: string;
  tooltip?: string;
  action: string;
}

@Component({
  standalone: false,
  selector: 'app-info-container',
  templateUrl: './info-container.component.html',
  styleUrls: ['./info-container.component.scss']
})
export class InfoContainerComponent {
  @Input() mainIcon: string = 'info';
  @Input() headerText: string = '';
  @Input() subtitleText: string = '';
  @Input() actionIcons: ActionIcon[] = [];
  @Input() isAddType?: boolean = false;
  @Input() customMainIconColor?: string;
  
  @Output() actionClicked = new EventEmitter<string>();
  @Output() addClicked = new EventEmitter<void>();

  onActionClick(action: string): void {
    this.actionClicked.emit(action);
  }

  onAddClick(): void {
    if (this.isAddType) {
      this.addClicked.emit();
    }
  }

  get mainIconStyle(): { [key: string]: string } {
    const baseStyle: { [key: string]: string } = {};
    
    if (this.customMainIconColor) {
      baseStyle['background'] = this.customMainIconColor;
    }
    
    return baseStyle;
  }
}